import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const data = [
  { name: "Progress", value: 10 },
  { name: "Remaining", value: 90 },
];

// Custom label
function renderCenterLabel() {
  return (
    <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle">
      <tspan x="50%" dy="-0.2em" fontSize="16" fill="#0074e4">
        ONGOING
      </tspan>
      <tspan x="50%" dy="1.2em" fontSize="14" fill="#0074e4">
        10%
      </tspan>
    </text>
  );
}

export default function DonutProgress() {
  return (
    <ResponsiveContainer width={`100%`} height={200} style={{ margin: "auto" }}>
      <PieChart>
        <defs>
          <linearGradient id="fillColor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0074e4" stopOpacity={1} />
            <stop offset="100%" stopColor="#67aaf1" stopOpacity={1} />
          </linearGradient>
        </defs>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius="65%"
          outerRadius="100%"
          fill="url(#fillColor)"
          stroke="none"
          labelLine={false}
          label={renderCenterLabel}
          startAngle={90}
          endAngle={-270}
        >
          <Cell key="filled" fill="url(#fillColor)" />
          <Cell key="empty" fill="#d0e8fb" />
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
}
